import { Game } from 'config/types/game'
import { useRequest } from 'hooks/useRequest'
import { useEffect, useMemo, useState } from 'react'
import GameService from 'services/GameService'

export const useSearchGames = (searchContent: string, gameCollectionId: number) => {
  const { execute } = useRequest()
  const [gamesSearch, setGamesSearch] = useState<Game[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!searchContent.length) return

    const fetch = async () => {
      setIsLoading(true)
      const response = await execute(
        GameService.getGames({ gameCollectionId, query: searchContent }, 0, 1000, false, true),
      )
      if (response?.data?.items) setGamesSearch(response.data.items)
      setIsLoading(false)
    }

    fetch()
  }, [searchContent, gameCollectionId])

  return useMemo(() => ({ gamesSearch, isSearching: isLoading }), [gamesSearch, isLoading])
}
